import { AnyAction } from "redux";

const baseRoutePath = (state = "", action: AnyAction): string => {
  switch (action.type) {
    default:
      return state;
  }
};

export default baseRoutePath;
